// @flow
import React, { Component } from 'react'
import type { OptionType } from '../types'
import { SelectItem, TextInputItem, ButtonItem } from '../controls/MassOperationsForm'

type Props = {|
  paramToChange: string,
  toReplace: string,
  replaceWith: string,
  isLoading: boolean,
  paramToChangeErrors: Array<string>,
  toReplaceErrors: Array<string>,
  replaceWithErrors: Array<string>,
  onChange: Function,
  onApply: Function
|}

const t = {
  apply: 'Применить',
  description: 'Текст',
  param_to_change_label: 'Где искать',
  replace_with_label: 'Заменить на',
  to_replace_label: 'Найти',
  url: 'URL'
}

export default class DescriptionUrlForm extends Component<Props> {
  render() {
    const {
      paramToChange,
      toReplace,
      replaceWith,
      isLoading,
      paramToChangeErrors,
      toReplaceErrors,
      replaceWithErrors
    } = this.props
    return (
      <div>
        <SelectItem
          inputGroupClassName="t-TemplateParamToChangeSelect"
          label={t.param_to_change_label}
          errors={paramToChangeErrors}
          value={paramToChange}
          options={this.paramToChangeOptions()}
          disabled={isLoading}
          onChange={(paramToChange) =>
            this.props.onChange({ paramToChange, paramToChangeErrors: [] })
          }
        />
        <TextInputItem
          inputGroupClassName="t-ToReplaceInput"
          label={t.to_replace_label}
          errors={toReplaceErrors}
          className="form-control input-item"
          value={toReplace}
          disabled={isLoading}
          onChange={(e) => this.props.onChange({ toReplace: e.target.value, toReplaceErrors: [] })}
        />
        <TextInputItem
          inputGroupClassName="t-ReplaceWithInput"
          label={t.replace_with_label}
          errors={replaceWithErrors}
          className="form-control input-item"
          value={replaceWith}
          disabled={isLoading}
          onChange={(e) =>
            this.props.onChange({ replaceWith: e.target.value, replaceWithErrors: [] })
          }
        />
        <ButtonItem
          buttonText={t.apply}
          onClick={() => this.props.onApply()}
          disabled={isLoading}
        />
      </div>
    )
  }

  paramToChangeOptions(): Array<OptionType> {
    return [
      { id: 'description', name: t.description },
      { id: 'url', name: t.url }
    ]
  }
}
